import { Component, OnInit } from '@angular/core';
import { ExtractorExampleObject } from '@app/_constants/chaos-text';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-extractor-info-dialog',
  templateUrl: './extractor-info-dialog.component.html',
  styleUrls: ['./extractor-info-dialog.component.less']
})
export class ExtractorInfoDialogComponent implements OnInit {
  extractorExample : any;
  extractorExampleSplit : any;
  constructor(public modal: NgbActiveModal) { }

  ngOnInit(): void {
    this.extractorExample = ExtractorExampleObject.extractorExample;
    this.extractorExampleSplit = this.extractorExample.split("\n");
  }

  cancel() {
    this.modal.close(false);
  }
}
